module.exports = __webpack_public_path__ + "static/media/icon-brand-recognition.1922b68a.svg";